import {
    CHALLENGES_REQUESTED,
    CHALLENGES_SUCCEEDED,
    CHALLENGES_FAILED,
    TAGS_REQUESTED,
    TAGS_SUCCEEDED,
    TAGS_FAILED,
    USERS_REQUESTED,
    USERS_SUCCEEDED,
    USERS_FAILED,
    REPORT_PREVIEW_REQUESTED,
    REPORT_PREVIEW_SUCCEEDED,
    REPORT_PREVIEW_FAILED,
    REPORT_CSV_REQUESTED,
    REPORT_CSV_SUCCEEDED,
    REPORT_CSV_FAILED,
    COUNTRIES_AND_CITIES_REQUESTED,
    COUNTRIES_AND_CITIES_SUCCEEDED,
    COUNTRIES_AND_CITIES_FAILED,
    CLEAR_REPORT,
    SET_SELECTED_COUNTRIES,
    REPORT_MAP_DATA_REQUESTED,
    REPORT_MAP_DATA_SUCCEEDED,
    REPORT_MAP_DATA_FAILED,
} from './constants';

const initialState = {
    // initialize empty array for challenges
    challenges: [],
    countries: [],
    selectedCountriesIds: [],
    loadingCountries: false,
    // initialize empty array for tags
    tags: [],
    // initialize empty array for users
    users: [],
    // initialize empty array for result / report
    report: [],
    // initialize empty array for preview result / report
    previewReport: [],
    // initialize empty array for selected challenges
    selectedChallenges: [],
    selectedCountries: [],
    // initialize empty array for selected tags
    selectedTags: [],
    tagSource: '',
    // initialize empty array for selected users
    selectedUsers: [],
    // initialize empty string for selected start date
    selectedStartDate: null,
    // initialize empty array for selected end date
    selectedEndDate: null,
    // initialize integer value of 0 for selected radius
    selectedRadius: 0,
    // initialize  null for selected zipcode
    selectedZipcode: null,
    // initialize empty string for error
    error: '',

    totalCount: '0',

    previewReportLoading: false,

    csvReportLoading: false,
    mapDataLoading: false,
    mapData: [],
    mapDataError: '',
    zoom: 1,
    dimensions: { top: 90, bottom: -90, left: -180, right: 180 },
};

export default function(state = initialState, action) {
    switch (action.type) {
        case SET_SELECTED_COUNTRIES: {
            return {
                ...state,
                selectedCountriesIds: action.countries,
            };
        }
        case REPORT_MAP_DATA_REQUESTED: {
            const { params } = action;
            return {
                ...state,
                mapDataLoading: true,
                mapDataError: '',
                mapData: [],
                ...params,
            };
        }
        case REPORT_MAP_DATA_SUCCEEDED: {
            const { mapData } = action;
            return {
                ...state,
                mapDataLoading: false,
                mapData,
            };
        }
        case REPORT_MAP_DATA_FAILED: {
            const { error } = action;
            return {
                ...state,
                mapData: [],
                mapDataLoading: false,
                mapDataError: error,
            };
        }
        case CHALLENGES_REQUESTED: {
            return {
                ...state,
            };
        }
        case CHALLENGES_SUCCEEDED: {
            const { challenges } = action;
            return {
                ...state,
                challenges,
            };
        }
        case CHALLENGES_FAILED: {
            const { error } = action;
            return {
                ...state,
                error,
            };
        }
        case COUNTRIES_AND_CITIES_REQUESTED: {
            return {
                ...state,
                loadingCountries: true,
            };
        }
        case COUNTRIES_AND_CITIES_SUCCEEDED: {
            const { countries } = action;
            return {
                ...state,
                countries,
            };
        }
        case COUNTRIES_AND_CITIES_FAILED: {
            const { error } = action;
            return {
                ...state,
                error,
            };
        }
        case TAGS_REQUESTED: {
            return {
                ...state,
            };
        }
        case TAGS_SUCCEEDED: {
            const { tags } = action;
            return {
                ...state,
                tags,
            };
        }
        case TAGS_FAILED: {
            const { error } = action;
            return {
                ...state,
                error,
            };
        }
        case USERS_REQUESTED: {
            return {
                ...state,
            };
        }
        case USERS_SUCCEEDED: {
            const { users } = action;
            return {
                ...state,
                users,
            };
        }
        case USERS_FAILED: {
            const { error } = action;
            return {
                ...state,
                error,
            };
        }
        case REPORT_PREVIEW_REQUESTED: {
            const { previewReportLoading } = action;
            const { selectedChallenges } = action;
            const { selectedUsers } = action;
            const { selectedTags } = action;
            const { selectedStartDate } = action;
            const { selectedEndDate } = action;
            const { selectedZipcode } = action;
            const { selectedRadius } = action;
            const { selectedCountries } = action;
            return {
                ...state,
                selectedChallenges,
                selectedUsers,
                selectedTags,
                selectedStartDate,
                selectedEndDate,
                selectedZipcode,
                selectedRadius,
                previewReportLoading,
                selectedCountries,
            };
        }
        case REPORT_PREVIEW_SUCCEEDED: {
            const { previewReport } = action;
            const { totalCount } = action;
            const { previewReportLoading } = action;
            return {
                ...state,
                previewReport,
                totalCount,
                previewReportLoading,
            };
        }
        case REPORT_PREVIEW_FAILED: {
            const { error } = action;
            const { previewReportLoading } = action;
            return {
                ...state,
                error,
                previewReportLoading,
            };
        }
        case REPORT_CSV_REQUESTED: {
            const { csvReportLoading } = action;
            const { selectedChallenges } = action;
            const { selectedUsers } = action;
            const { tagSource } = action;
            const { selectedStartDate } = action;
            const { selectedEndDate } = action;
            const { selectedZipcode } = action;
            const { selectedRadius } = action;
            const { selectedCountries } = action;
            return {
                ...state,
                selectedChallenges,
                selectedUsers,
                tagSource,
                selectedStartDate,
                selectedEndDate,
                selectedZipcode,
                selectedRadius,
                csvReportLoading,
                selectedCountries,
            };
        }
        case REPORT_CSV_SUCCEEDED: {
            const { report } = action;
            const { csvReportLoading } = action;
            const { totalCount } = action;
            return {
                ...state,
                report,
                csvReportLoading,
                totalCount,
            };
        }
        case REPORT_CSV_FAILED: {
            const { error } = action;
            const { csvReportLoading } = action;
            return {
                ...state,
                error,
                csvReportLoading,
            };
        }
        case CLEAR_REPORT: {
            const { report } = action;
            const { previewReport } = action;
            return {
                ...state,
                report,
                previewReport,
            };
        }
        default:
            return state;
    }
}
